import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./include/Header";
import Footer from "./include/Footer";
import MainContent from "./Components/MainContent";
import Blogs from "./Components/blogs/Blogs";
import BlogDetails from "./Components/blogs/BlogDetails";
import SingleProduct from "./Components/product/SingleProduct";
import Aboutus from "./Components/Aboutus";
import ProductList from "./Components/product/ProductList";
import Checkout from "./Components/Checkout";
import "swiper/css";
import "swiper/css/navigation";
import JewelleryCategories from "./Components/JewelleryCategories";
import CategoryPage from "./Components/CatergoryPage";
import { ProductProvider } from "./context/ProductContext";
import OfferSlider from "./Components/OfferSlider";
import AccountDashboard from "./Components/AccountDashboard";
import ProductDetail from "./Components/product/ProductDetail";
import { CartProvider } from "./context/CartContext";   // ✅ ADD THIS
import { Toaster } from "react-hot-toast";
import ProtectedRoute from "./routes/ProtectedRoute";



function App() {
  return (
    <BrowserRouter>

      <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: "#fff",
              color: "#333",
              borderRadius: "12px",
              border: "1px solid #eee",
              padding: "14px 18px",
              boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
            },
            success: {
              iconTheme: {
                primary: "#28a745",
                secondary: "#fff",
              },
            },
            error: {
              iconTheme: {
                primary: "#dc3545",
                secondary: "#fff",
              },
            },
          }}
      />

      {/* ✅ Wrap your whole app with ProductProvider */}
      <CartProvider>
        <div className="main-wrapper">
          <OfferSlider/>
          <Header />
          <Routes>
            <Route path="/" element={<MainContent />} />
            <Route path="/Blogs" element={<Blogs />} />
            <Route path="/BlogDetails" element={<BlogDetails />} />
            <Route path="/singleProduct" element={<SingleProduct />} />
            <Route path="/Aboutus" element={<Aboutus />} />
            <Route path="/ProductList" element={<ProductList />} />
            <Route path="/JewelleryCategories" element={<JewelleryCategories />} />
            <Route path="/collection/:slug" element={<CategoryPage />} />
            <Route path="/productlist" element={<ProductList />} />
             {/* <Route path="/products/gold-charm-bracelet" element={<ProductDetail/>} /> */}
             <Route path="/products/:slug" element={<ProductDetail />} />
             <Route path="/checkout" element={<Checkout />} />
             <Route
              path="/account"
              element={
                <ProtectedRoute>
                  <AccountDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
          <Footer />
        </div>
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
